define(function(require) {
	const add_applicant_tpl = require('./t_lov_add_applicant.hbs');
	const applicant_model = require('civicsModels/applicant_model');
	const code_definition_collection = require('civicsCollections/code_definition_collection');
	const filter_code_collection = require('civicsCollections/cdr/filter_code_collection');
	const IpsModel = require('civicsBase/ipsModel');
	const IpsCollection = require('civicsBase/ipsModelCollection');
	const ViewManager = require('civicsUtils/view_manager');
	const constants = require('civicsUtils/constants');
	const Utils = require('civicsUtils/general_utilities');
	const TypeUtils = require('civicsUtils/type_utilities');
	const AvailableFeatures = require('civicsUtils/available_features');
	const SelectFavoritesView = require('civicsViews/favoriteContacts/v_lov_favorite');
	const FavoriteController = require('civicsViews/favoriteContacts/controllers/main_controller');
	const FavoritesCollection = require('civicsCollections/portal/favorite_contact_collection');
	return Marionette.LayoutView.extend({
		className:'add-applicant-modal',
		template:add_applicant_tpl,
		regions: {
			favoritesListRegion: '@ui.favoriteDiv'
		},

		events:{
			'click @ui.companyIndividualRadios':'companyIndividualSelected',
			'click @ui.addApplicantButton':'addApplicantClicked',
			'click @ui.cancelApplicantButton':'cancelApplicantClicked',
			'click @ui.clearLink':'clearLinkClicked',
			'click @ui.closeModalButton':'cancelApplicantClicked',
			'click @ui.selectFlowButton': 'selectFlowClicked',

		},
		childEvents:{
			'cancel:clicked':'cancelApplicantClicked',
			'contact:added': 'callContactAdd'
		},
		ui:{
			companyIndividualRadios:'.company-individual-radio',
			addApplicantButton:'.add-applicant',
			selectFavoritesButton:'.select-favorites-next',
			selectFlowButton: '.selectFlow',
			favoriteDiv: '.favorites-container-modal',
			addApplicantDiv:'.add-applicant-form-div',
			cancelApplicantButton:'.cancel-applicant',
			companyRow:'.company-row',
			individualRow:'.individual-row',
			formInputs: 'input',
			clearLink:'.clear-all-filters',
			businessName:'input[name=companyName]',
			lastName:'input[name="contact.identity.lastName"]',
			favoriteRadio: 'input[name="select-add-applicant"][value="favoritesFlow"]',
			applicantRadio: 'input[name="select-add-applicant"][value="applicantFlow"]',
			applicantFlowRadio: 'input[name="select-add-applicant"][value="applicantFlow"]',
			capacitySelect: '#capacity-type',
			applicantTypeSelect: '#applicant-type',
			closeModalButton: '.bbm-btn-close',
			addApplicantButtons: '.add-applicant-buttons'
		},
		isModal:true,
		config:{},
		initialize:function(options){
			if(options){
				if(options.config){
					this.config = options.config;
				}
				if(options.isModal === false){
					this.isModal = false
				}
				if(options.instrumentType){
					this.config.instrumentType = options.instrumentType;
				}
				this.modalRegion = options.modalRegion;
			}
			this.applicantTypes = options.applicantTypes;
			this.additionalCapacityTypes = options.additionalCapacityTypes;
			this.applicantCollection = options.applicantCollection;
			this.additionalCapacityTypesPromise = $.Deferred();
			this.loadAdditionalCapacityTypes();
			//hide contact types if it is empty, or only has one option.
			//Select the only option if that is the case.
			this.config.globalConfig = ViewManager.globalConfig().toJSON();

			this.businessType = 'I'
			var contactTypes = this.config.globalConfig.contactTypes;//.toJSON().splice(1,1);
			this.contactCode = "";
			this.showContactSelect = true;
			this.modalRegion = options.modalRegion;
			this.favoriteContactEnabled = AvailableFeatures.FavoriteContacts() && this.config.globalConfig.favoriteContact == 'Show';

			if(contactTypes.length<=1) {
				this.showContactSelect = false;
				if (contactTypes.length == 1) {
					this.contactCode = contactTypes[0].code;
				}
			}

			this.config.showState = this.config.globalConfig.usesContactState != 'Hide';        //equals show or required
			this.setApplicantConfig();
			this.loadFavorites();
		},
		onShow: function() {
			ViewManager.loading(true);
			$.when(
				this.additionalCapacityTypesPromise, this.favoritesReadyPromise
			).done(function() {
				this.render();
				ViewManager.loading(false);
			}.bind(this));
		},
		onRender:function(){
			if(this.businessType == 'C'){
				this.ui.individualRow.hide();
				this.ui.companyRow.show();
			} else if(this.businessType =='I') {
				this.ui.companyRow.hide();
				this.ui.individualRow.show();
			}

			this.$el.rhythmCivicsTooltipInit();
			this.$el.rhythmThemeInitCivics();
			this.$el.find('.droppy').rhyCivicsDroppy();
			this.$el.rhythmThemeInit();
			//let moniker = this.additionalCapacityTypes ? this.additionalCapacityTypes.moniker : '';
			this.setupFilterCodes(this.config.instrumentType);
			if(this.additionalCapacityTypes && this.additionalCapacityTypes.length <= 1){
				this.ui.capacitySelect.parent().find('.droppy-list .droppy-option:not([data-val=""])').attr('aria-selected', 'true');
				this.ui.capacitySelect.closest('.droppy').hide();
			}
			this.setupFavorites();
			ViewManager.resetErrorMessages(this);

		},
		setupFavorites: function(){
			if(this.favoriteContactEnabled){
				this.showFavoritesView();
				this.setDefaultOption();
			}
		},
		loadFavorites: function () {
			if (this.favoriteContactEnabled) {
				this.favoritesController = new FavoriteController(this.config);
				this.favorites = new FavoritesCollection();
				let sortAvailable = true;
				this.favoritesReadyPromise = this.favoritesController.loadFavorites(sortAvailable);

				this.favoritesReadyPromise.done((data) => {
					this.favorites.add(data.favorites);
				});
			}
		},
		showFavoritesView: function () {
			let favoritesView = new SelectFavoritesView({
				config: this.config,
				collection: this.favorites,
				additionalCapacityTypes: this.additionalCapacityTypes,
				applicantTypes: this.applicantTypes,
				controller: this.favoritesController,
				submitApplCollection : this.applicantCollection
			});			
			this.favoritesListRegion.show(favoritesView);
		},
		setDefaultOption: function (){
			this.ui.applicantFlowRadio[0].checked = true;
			this.getRegion('favoritesListRegion').$el.hide();
		},
		selectFlowClicked: function (e) {
			var $input = $(e.currentTarget).find('input[type="radio"]');
			this.flowType = $input.val();

			// Set checked via native DOM property to trigger CSS :checked pseudo-class
			this.ui.favoriteRadio[0].checked = (this.flowType === 'favoritesFlow');
			this.ui.applicantRadio[0].checked = (this.flowType === 'applicantFlow');

			if (this.flowType === 'favoritesFlow') {
				this.ui.addApplicantDiv.fadeOut(500, () => {
					this.getRegion('favoritesListRegion').$el.fadeIn();
					this.$el.find('.add-applicant-modal-container').addClass('showFavorites');
				});

				this.ui.addApplicantButtons.hide(); 
			} else if (this.flowType === 'applicantFlow') {
				this.ui.favoriteDiv.fadeOut(500, () => {
					this.ui.addApplicantDiv.fadeIn();
					this.$el.find('.add-applicant-modal-container').removeClass('showFavorites');
				});

				this.ui.addApplicantButtons.show();
			}
		},
		setApplicantConfig: function(){
			this.config.showApplicantType = this.config.globalConfig.usesApplicantType == 'Show';
			this.config.showCapacity = this.config.globalConfig.usesCapacity != 'Hide';
			this.config.requireCapacity = this.config.globalConfig.usesCapacity == 'Required';
		},
		loadAdditionalCapacityTypes: function() {
			if (this.config.globalConfig.usesCapacity != 'Hide' && !this.additionalCapacityTypes) {
				var tableName = 'ApplicantCapacityType';
				if (this.config.instType.businesslicense || this.config.instType.codeenforcement)
					tableName = 'ContactCapacityType';
				else if( this.config.instType.tradelicense )
					tableName = 'LicenseContactCapacityType';

				if(AvailableFeatures.FilterCapacities()){
					this.additionalCapacityTypes = new filter_code_collection();
					this.additionalCapacityTypes.comparator = function (a) {
						var aSort = a.get('description');
						return aSort.toLowerCase();
					};

					//this.config.recordType for Add Instrument
					//this.config.apType for Instrument Detail
					var recordType = this.config.recordType ? this.config.recordType : this.config.apType;
					var capacityType = 'Additional';
					this.additionalCapacityTypes.moniker = 'Hansen.CDR.' + this.config.instrumentType + "." + tableName;
					this.additionalCapacityTypes.productFamily = this.config.instrumentType;
					this.additionalCapacityTypes.codeType = 'Capacity';		//Filter Code Type
					this.additionalCapacityTypes.applicationType = recordType;
					this.additionalCapacityTypes.capacityType = capacityType;

					this.additionalCapacityTypes.fetch().done(function () {
						this.additionalCapacityTypesPromise.resolve();
					}.bind(this));
				}
				else{
					this.additionalCapacityTypes = new code_definition_collection();
					this.additionalCapacityTypes.comparator = function (a) {
					  var aSort = a.get('description');
					  return aSort.toLowerCase();
					};

					this.additionalCapacityTypes.moniker = 'Hansen.CDR.' + this.config.instrumentType + "." + tableName;

					this.additionalCapacityTypes.fetch().done(function () {
					  this.additionalCapacityTypesPromise.resolve();
					}.bind(this));
				}
			} else {
				this.additionalCapacityTypesPromise.resolve();
			}
		},
		callContactAdd: function(childView, data){
			this.triggerMethod('contact:added', data);
		},
		clearLinkClicked:function(e){
			// this.ui.formInputs.val('');
			if (e) {
				e.preventDefault();
				e.stopPropagation();
			}
			this.render();
		},
		companyIndividualSelected:function(e){
			$radio = $(e.target);
			if($radio.val() == 'C'){
				this.businessType = 'C';
				this.ui.individualRow.hide();
				this.ui.individualRow.find('input').each(function(){
					$(this).val('');
				});
				this.ui.companyRow.show();
			} else {
				this.businessType = 'I';
				this.ui.companyRow.hide();
				this.ui.companyRow.find('input').val('').each(function(){
					$(this).val('');
				});
				this.ui.individualRow.show();
			}
		},
		getData:function(){
			var data = Backbone.Syphon.serialize(this.$el, {
				exclude:['companyIndividual']
			});

			data = _.extend(data,Utils.serializeDroppy(this.$el));
			if(data.contactType != null){
				applType = data.contactType;
				data.contactType = Utils.getApplicantType(this.config.instrumentType, applType); //need to get applicant type form in number
			}
			//TradeLicense must have ApplicantType set to 1
			if(this.config.instrumentType.toLowerCase() == 'tradelicense'){
				data.contactType = "1";
			}

			//If we are hiding the ApplicantType, set to 'Other'
			if( !this.config.showApplicantType && !this.config.instType.servicerequest && !this.config.instType.tradelicense){
				if( this.config.instType.businesslicense ){
					data.contactType = 1;
				}
				else{
					data.contactType = 4;
				}
			}

			if( data.capacity ){
				let desc = Utils.civicsDropdownText(this.ui.capacitySelect);
				data.capacity = {code: data.capacity, description: desc};
			} else {
				//IPS expects a capacity attribute if the global config is set to show/required
				//if data.capacity doesn't exist, but is required, it will be caught in validation.
				//here, we default it to null if a capacity wasn't selected.
				data.capacity = {code:""};
			}

			if( data.contactType ){
				let desc = Utils.civicsDropdownText(this.ui.applicantTypeSelect);
				data.contactTypeDescription = desc;
			} else {
				data.contactTypeDescription = {code:""};
			}

			//company name is reported via last name
			if($('input[name=companyIndividual]:checked').val()=='C'){
				data.contact.identity.lastName = data.companyName;
			}
			//remove extraneous data
			delete data.companyName;
			return data;
		},
		addApplicantClicked:function(){
			ViewManager.resetErrorMessages(this);
			var data = this.getData();
			data.contact.emailAddress = data.contact.emailAddress.trim();

			var prefixerror = {};
			prefixerror.validationError = {};
			var error = {};
			error.validationError = {};


			//Check required fields
			var isValid = true;
			if(  _.isEmpty(data.contact.identity.lastName) ){
				isValid = false;
				if($('input[name=companyIndividual]:checked').val()=='C'){
					error.validationError.companyName = i18n.t('CIVICS.COMMON.BUSINESS_NAME_REQ_ERROR');
				} else {
					prefixerror.validationError.lastName = i18n.t('CIVICS.COMMON.LAST_NAME_REQ_ERROR');
				}
			}
			if (this.config.requireCapacity && (_.isEmpty(data.capacity) || _.isEmpty(data.capacity.code))) {
				error.validationError.capacity = i18n.t('CIVICS.INSTRUMENT_SUBMIT.CAPACITY_REQ_ERROR');
				isValid = false;
			}

			if( !this.config.instType.tradelicense ){
				if( this.config.showApplicantType) {
					if(data.contactType == null || data.contactType === ''){
						error.validationError.contactType = i18n.t('CIVICS.INSTRUMENT_SUBMIT.APPLICANTTYPE_REQ_ERROR');
						isValid = false;
					}
				}
			}

			//Validate email
			var emailRegex = (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
			var email = data.contact.emailAddress;
			var maxEmailLength = AvailableFeatures.MaxEmailLength();

			if(!_.isEmpty(email) && !emailRegex.test(email)){
				error.validationError['contact.emailAddress'] = i18n.t('CIVICS.ACCOUNT.INVALID_EMAIL');
				isValid = false;
			} else { //check emailLength, even though this shouldn't ever be possible with a maxlength on the field
				if(email.length > maxEmailLength){
					error.validationError['contact.emailAddress'] = i18n.t('CIVICS.ACCOUNT.EMAIL_LENGTH_ERROR', {max:maxEmailLength});
					isValid = false;
				}
			}

			if( isValid ){
				var model = new applicant_model();
				model.set(data);
				model.instrumentType = this.config.instrumentType.toLowerCase();

				this.triggerMethod('applicant:added',model,data.contact.identity.firstName,data.contact.identity.lastName);
				this.sortApplicants();
				if(this.modalRegion) {
					this.modalRegion.hideModal(this.focusNext());
				} else {
					this.destroy();
				}
			}else {
				ViewManager.errorToWindow(prefixerror, this, { prefix: 'contact.identity' });
				ViewManager.errorToWindow(error, this);
			}

		},
		focusNext: function() {
			// find the applicant list and focus on the last added item's delete button (can't seem to make this work calling the container from the previous layout view)
			$(this.config.focusEl).last().focus();
		},
		cancelApplicantClicked:function(){
			if(this.modalRegion) {
				this.modalRegion.hideModal();
			} else {
				this.destroy();
			}
		},
		sortApplicants: function(model){
			$('.attachment-list').html(
			$('.attachment-list').children('li').sort(function (a, b) {
				return $(a).text().toUpperCase().localeCompare(
						$(b).text().toUpperCase());
				})
			);
		},
		templateHelpers:function(){
			var self = this;
			var instType = self.config.instrumentType.toLowerCase();

			return {
				isBusiness: this.businessType == 'C' || this.businessType == null,
				isIndividual: this.businessType == 'I',
				config: this.config,
				contactTypes:this.config.globalConfig.contactTypes,//').toJSON(),
				additionalCapacityTypes: this.additionalCapacityTypes ? this.additionalCapacityTypes.toJSON() : '',
				states:this.config.globalConfig.states,
				applicantTypes: this.applicantTypes ? this.applicantTypes.toJSON() : '',
				contactCode:this.contactCode,
				showContactSelect:this.showContactSelect,
				isModal:this.isModal,
				showBlankApplType:(instType != 'businesslicense' && instType != 'tradelicense'),//currently these cannot create appl with no type
				hideApplTypeSelect:instType == 'tradelicense' || !this.config.showApplicantType,//tradelicense has no choices for applType
				hideApplTypeRow:(!this.showContactSelect && instType == 'tradelicense'),//if applType and contactType aren't shown, hide row
				maxEmailLength: AvailableFeatures.MaxEmailLength(),
				showSelectOption: this.favoriteContactEnabled
			}
		}
	});
});
